import {LoDashStatic} from "lodash";
const _ = <LoDashStatic> require('lodash');
require('./distributionKeyDetailsDialog.less');

class DistributionKeyDetailsDialogController {
    activeKeyForEdit;
    activeKey = {
        name: "",
        totalVal: 0,
        active: true,
        months: [
            {title:'Januar', name:'january', val:0},
            {title:'Februar', name:'february', val:0},
            {title:'Mars', name:'march', val:0},
            {title:'April', name:'april', val:0},
            {title:'Mai', name:'may', val:0},
            {title:'Juni', name:'june', val:0},
            {title:'Juli', name:'july', val:0},
            {title:'August', name:'august', val:0},
            {title:'September', name:'september', val:0},
            {title:'Oktober', name:'october', val:0},
            {title:'November', name:'november', val:0},
            {title:'Desember', name:'december', val:0}
        ]
    };

    constructor(private toastService, private DistributionKeys, private $filter, private $mdDialog){
    }

    $onInit() {
        if(this.activeKeyForEdit){
            this.activeKey.name = this.activeKeyForEdit.name;
            this.activeKey.active = this.activeKeyForEdit.active;
            _.forEach(this.activeKey.months, (month)=>{
                month.val = this.activeKeyForEdit[month.name];
            });
            this.reportPercent();
        }
    }

    saveDistributionKey () {
        var distKey = { active: this.activeKey.active,  name: this.activeKey.name };
        _.forEach(this.activeKey.months, (month)=>{
            distKey[month.name] = month.val;
        });
        (this.activeKeyForEdit ? this.DistributionKeys.updateDistributionKey({val: this.activeKeyForEdit.id}, distKey) : this.DistributionKeys.postDistributionKeys(distKey)).$promise.then(
            () => {
                this.$mdDialog.hide("success");
            }, (error) => {
                this.toastService.parseError(error);
            }
        );
    };

    hide () {
        this.$mdDialog.hide();
    };
    cancel () {
        this.$mdDialog.cancel();
    };

    reportPercent () {
        var percVal = 0;
        this.activeKey.months.forEach(function(month){
            if(month.val){
                percVal += month.val;
            }
        });
        this.activeKey.totalVal = percVal;
    };
}

class DistributionKeyDetailsDialogOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcDistributionKeyDetailsDialogController";
    public template: any = require('./distributionKeyDetailsDialog.html');
    bindings: any = {
        activeKeyForEdit:'='
    };
}

rkcApp.controller("rkcDistributionKeyDetailsDialogController", ['toastService', 'DistributionKeys', '$filter', '$mdDialog', function( toastService, DistributionKeys, $filter, $mdDialog){
    return new DistributionKeyDetailsDialogController(toastService, DistributionKeys, $filter, $mdDialog);
}])
    .component("distributionKeyDetailsDialog", new DistributionKeyDetailsDialogOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/distributionKeys/distributionKeyDetailsDialog/distributionKeyDetailsDialog.ts
 **/